import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoEmail } from "../../../types/documento/email/DocumentoEmail";
import { DocumentoEmailDTO } from "../../../types/documento/email/DocumentoEmailDTO";
import { DocumentoEmailList } from "../../../types/documento/email/DocumentoEmailList";

const endpointUrl = configUrls.DOCUMENTO_EMAIL_EP;

/**
 * Tipo para parâmetros de busca de emails
 */
type Search = {
    id: string;
    search: string;
};

/**
 * Obtém a lista de emails de um documento
 * @param id - ID do documento
 * @param search - Termo de busca
 */
function getDocumentosEmails({ id, search }: Search) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/emails/${id}?search=${search}`,
        method: "GET",
    }
}

/**
 * Obtém um email específico de um documento
 * @param id - ID do email
 */
function getDocumentoEmail(id: string) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/email/${id}`,
        method: "GET",
    }
}

/**
 * Verifica se um email existe
 * @param id - ID do email
 
function getDocumentoEmailExists(id: string) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/email/exists/${id}`,
        method: "GET",
    }
}
    */

/**
 * Remove um email de um documento
 * @param id - ID do email
 */
function deleteEmailDocumento(id: string) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/email/${id}`,
        method: "DELETE",
    }
}

/**
 * Adiciona um novo email a um documento
 * @param data - Dados do email a ser adicionado
 */
function darEmailDocumento(data: DocumentoEmailDTO) {
    return {
        url: `${endpointUrl}/email`,
        method: "POST",
        body: data,
    }
}

export const documentoEmailApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getDocumentosEmails: query<DocumentoEmailList[], { id: string, search: string }>({
            query: getDocumentosEmails,
            providesTags: ["Email"],
        }),

        getDocumentoEmail: query<DocumentoEmail, string>({
            query: getDocumentoEmail,
            providesTags: ["Email"],
        }),

        /* 
         getDocumentoEmailExists: query<boolean, string>({
             query: getDocumentoEmailExists,
             providesTags: ["Email"],
         }),
         */

        createEmailDocumento: mutation<void, DocumentoEmailDTO>({
            query: darEmailDocumento,
            invalidatesTags: ["Email"],
        }),
        deleteEmailDocumento: mutation<void, string>({
            query: deleteEmailDocumento,
            invalidatesTags: ["Email"],
        }),

    }),
});

export const {
    useGetDocumentosEmailsQuery,
    useCreateEmailDocumentoMutation,
    useDeleteEmailDocumentoMutation,
    useGetDocumentoEmailQuery,
    //useGetDocumentoEmailExistsQuery
} = documentoEmailApiSlice